/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Analytics_Screenshotunavailable_Message1Inputs */

const en_analytics_screenshotunavailable_message1 = /** @type {(inputs: Analytics_Screenshotunavailable_Message1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cannot take a screenshot of this card because no data is available for the selected filters.`)
};

/**
* | output |
* | --- |
* | "Cannot take a screenshot of this card because no data is available for the selected filters." |
*
* @param {Analytics_Screenshotunavailable_Message1Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const analytics_screenshotunavailable_message1 = /** @type {((inputs?: Analytics_Screenshotunavailable_Message1Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Analytics_Screenshotunavailable_Message1Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_analytics_screenshotunavailable_message1(inputs)
});
export { analytics_screenshotunavailable_message1 as "analytics_screenshotUnavailable_message" }